const axios = require('axios').default;
const { DateTime } = require('luxon');
import slugify from 'slugify';
import SHA256 from 'crypto-js/sha256.js';
//import jsonConcat from 'json-concat';

import { ConfigData } from "src/config.js";

const getDescriptionDisplay = (data, released, companies) => {
    var details = '';
    switch (released) {
        case 'cinedapt-not-available':
            details = `${companies.display} released ${data.title} prior to Cinedapt being available to protect against piracy.`;
            break;
        case 'cinedapt-declined':
            details = `${companies.display} declined to protect ${data.title} against piracy with Cinedapt.`;
            break;
        case 'cinedapt-still-available':
            details = `${companies.display} still ${companies.singular} a chance to protect ${data.title} against piracy with Cinedapt.`;
            break;
        default:
            details = `${companies.display} released ${data.title} prior to Cinedapt being available to protect against piracy.`;
    }
    return details;
}

const getDetailsDisplay = (data, released, companies) => {
    var details = '';
    var releasedDetails = '';
    var linkDetails = `Cinedapt is the only patented and proven solution to protect against film piracy.  Learn more by visiting: <a href="https://cinedapt.com?piracy-plus" target="_blank">https://cinedapt.com</a>`;
    var optionsDetails = `As a consumer, you can either set your sails in search of ${data.title} to watch for free, or you can purchase the film through a provider listed below.`;
    var aboutDetails = `Cinedapt offers additional anti-piracy protection services even after a film has leaked to pirates.`;
    var productionDetails = `${companies.display} still ${companies.singular} the option to enhance ${data.title} with Cinedapt.  Additional anti-piracy protection services are available even for films already leaked to pirates.`;

    switch (released) {
        case 'cinedapt-not-available':
            releasedDetails = `${companies.display} released ${data.title} prior to Cinedapt being available to protect against piracy.`;
            details = `${releasedDetails}  ${optionsDetails}  ${productionDetails}  ${linkDetails}`;
            break;
        case 'cinedapt-declined':
            releasedDetails = `${companies.display} declined to protect ${data.title} against piracy with Cinedapt.`;
            details = `${releasedDetails}  ${optionsDetails}  ${productionDetails}  ${linkDetails}`;
            break;
        case 'cinedapt-still-available':
            releasedDetails = `${companies.display} still ${companies.singular} a chance to protect ${data.title} against piracy with Cinedapt.`;
            aboutDetails = `Cinedapt also offers additional anti-piracy protection services once a film has leaked to pirates.`;
            details = `${releasedDetails}  ${aboutDetails}  ${linkDetails}`;
            break;
        default:
            releasedDetails = `${companies.display} released ${data.title} prior to Cinedapt being available to protect against piracy.`;
            details = `${releasedDetails}  ${optionsDetails}  ${productionDetails}  ${linkDetails}`;
    }
    return details;
}

const checkReleaseDate = (data) => {
    // cinedapt-not-available
    // cinedapt-declined
    // cinedapt-still-available
    var released = 'cinedapt-still-available';
    if (data.release_date) {
        var year = data.release_date.split('-')[0];
        if (year < 2019) {
            released = 'cinedapt-not-available';
        } else {
            released = 'cinedapt-declined';
        }
    }
    if (data.streaming) {
        if (Object.keys(data.streaming)[0]) {
            if (released === 'cinedapt-still-available') {
                released = 'cinedapt-declined';
            }
            /*
            if (data.release_date) {
                var year = data.release_date.split('-')[0];
                if (year > 2019) {
                    released = 'cinedapt-still-available';
                }
            }
            */
        }
    }
    if (data.status) {
        if (data.status === 'In Production') {
            released = 'cinedapt-still-available';
        }
        console.log(data.status);
    }
    return released;
}

const getCompanies = (data) => {
    var companies = {
        display: 'The production and distribution companies',
        singular: 'have'
    };
    if (data.production_companies.length > 0) {
        if (data.production_companies.length === 1) {
            companies.display = data.production_companies[0].name;
            companies.singular = 'has';
        }
        if (data.production_companies.length === 2) {
            companies.display = data.production_companies[0].name + ' and ' + data.production_companies[1].name;
        }
        if (data.production_companies.length > 2) {
            companies.display = data.production_companies[0].name + ', ' + data.production_companies[1].name + ', and ' + data.production_companies[2].name;
        }
    }
    return companies;
}

const getCompaniesDescription = (data) => {
    var companies = {
        display: 'The production and distribution companies',
        singular: 'have'
    };
    if (data.companies.length > 0) {
        if (data.companies.length === 1) {
            companies.display = data.companies[0];
            companies.singular = 'has';
        }
        if (data.companies.length === 2) {
            companies.display = data.companies[0] + ' and ' + data.companies[1];
        }
        if (data.companies.length > 2) {
            companies.display = data.companies[0] + ', ' + data.companies[1] + ', and ' + data.companies[2];
        }
    }
    return companies;
}

export const getDescription = (data) => {
    console.log(data);
    //var released = checkReleaseDate(data);
    var companies = getCompaniesDescription(data);
    var description = getDescriptionDisplay(data, 'cinedapt-declined', companies);
    return description;
}

export const getDetails = (data) => {

    console.log(data);

    var released = checkReleaseDate(data);
    var companies = getCompanies(data);
    var details = getDetailsDisplay(data, released, companies);
    console.log(details);

    return details;
}

export default { getDescription, getDetails };